var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"duplicates-job-editor-modal"}},[_c('ErrorPopup',{attrs:{"error":_vm.error}}),_c('memlist-modal',{ref:"edit-modal",attrs:{"size":"lg"}},[_c('DuplicatesJobEditor',{attrs:{"item":_vm.local_item},on:{"created":_vm.job_created,"updated":_vm.job_updated,"cancel":() => { this.$refs['edit-modal'].hide(); }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }